import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import {getLink} from "@hooks/PagesData/getLink"

import Link from "../../Link/Link"
import {Translate} from "../../Translate/Translate"

import styles from "./FooterTop.module.scss"

type Props = {}

const socialImage = {
	height: 40,
	width: 40,
}

const FooterTop = (props: Props): any => {
	return (
		<div className={styles.footer__top_container}>
			<div className={styles.textContainer}>
				<div className={styles.textBox}>
					<Paragraph
						content={
							<Link
								className={styles.link}
								link={"tel:+358 10 232 7770"}
							>
								<Translate capitalizeFirst>
									Switchboard:
								</Translate>{" "}
								<span>+358 10 232 7770</span>
							</Link>
						}
						size={"XS"}
					/>

					<Paragraph
						className={styles.textBox}
						content={
							<Link
								className={styles.link}
								link={"tel:+358 10 232 7771"}
							>
								<Translate capitalizeFirst>
									Technical customer service
								</Translate>{" "}
								<Translate>and</Translate>{" "}
								<Translate capitalizeFirst>Helpdesk:</Translate>{" "}
								<span>+358 10 232 7771</span>
							</Link>
						}
						size={"XS"}
					/>
				</div>
			</div>
			<div className={styles.footer__top_btn}>
				<div className={styles.socialLinksContainer}>
					<Link link={getLink("twitter")}>
						<NewResponsiveImage
							alt={"x"}
							containerClassName={styles.socialImageContainer}
							imageClassName={styles.socialImage}
							{...socialImage}
							src={"/logo-x-black.png"}
						/>
					</Link>
					<Link link={getLink("linkedin")}>
						<NewResponsiveImage
							alt={"linkedin"}
							containerClassName={styles.socialImageContainer}
							imageClassName={styles.socialImage}
							{...socialImage}
							src={"/107159_circle_linkedin_icon.png"}
						/>
					</Link>
					<Link link={getLink("facebook")}>
						<NewResponsiveImage
							alt={"facebook"}
							containerClassName={styles.socialImageContainer}
							imageClassName={styles.socialImage}
							{...socialImage}
							src={
								"/104458_facebook_social-media_fb_social_icon.png"
							}
						/>
					</Link>
					{/* Just need to hide, not delete */}
					{/* <Link link={getLink("youtube")}>
						<NewResponsiveImage
							alt={"youtube"}
							containerClassName={styles.socialImageContainer}
							imageClassName={styles.socialImage}
							{...socialImage}
							src={"/104445_video_youtube_icon.png"}
						/>
					</Link> */}
					<Link link={getLink("instagram")}>
						<NewResponsiveImage
							alt={"instagram"}
							containerClassName={styles.socialImageContainer}
							imageClassName={styles.socialImage}
							{...socialImage}
							src={"/1161954_instagram_icon.png"}
						/>
					</Link>
				</div>
			</div>
		</div>
	)
}

export default FooterTop
